import React from 'react'
import { mappaGiorni3 } from '../../../form/BSSDateSelector';

import __t from "../../../../lib/traduzioni";
import {format, isValid} from 'date-fns'
import useBSSLogger from '../../../../hooks/useBSSLogger';
import BSSNumber from '../../../form/BSSNumber';
import BSSText from '../../../form/BSSText';
import BSSSwitch from '../../../form/BSSSwitch';
import { InputAdornment } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import AvatarAddizionale from '../AvatarAddizionale';

const {logger} = useBSSLogger();


const filtraPreventivi = ({preventivo, filter}) => {

    const esitoStampa = filtraStampanteNonRichiesta({preventivo, filter});
    const esitoCategorie = filtraCategorieAddizionali({preventivo, filter});

    const esito = esitoStampa && esitoCategorie; 

    logger.finest("[CONTESTO FILTRA PREVENTIVI] "+ preventivo.description + " esito stampante non richiesta", esitoStampa, "esito categorie addizionali", esitoCategorie, esito)

    return esito;
}



const filtraStampanteNonRichiesta = ({preventivo, filter}) => {    

    let esito = true;
    const {printernotrequired} = filter;

    if(printernotrequired === true){
        esito = preventivo.printerrequired === !printernotrequired
    }
    
    logger.finest("[CONTESTO FILTRI STAMPANTE NON RICHIESTA]filtro i preventivi. L'utente può spedire senza stampante?", preventivo.description, "filtro", printernotrequired, esito)


    return esito;
}

const filtraCategorieAddizionali = ({preventivo, filter}) => {
        
    let esito = true;

    /**
     * id delle categorie del filtro
     */
    const idCategorieFiltri = Object.keys(filter)
        .filter(k => k.startsWith("filtri.categorieAddizionali"))
        .filter(k => filter[k] === true)
        .map(k => Number(k.split(".")[2]))

    logger.finest("[CONTESTO FILTRI CATEGORIE ADDIZIONALI]applico filtro per categorie addizionali", filter, idCategorieFiltri)


    if((idCategorieFiltri ?? []).length > 0){

        /**
         * id delle categorie del preventivo
         */
        const idCategoriePreventivo = preventivo.listaaddizionali.map(a => Number(a.categoria.id));
        
        esito = idCategorieFiltri.every(a => idCategoriePreventivo.includes(a)); 

        logger.finest("[CONTESTO FILTRI CATEGORIE ADDIZIONALI]il preventivo ", preventivo.description, "con categorie addizionali", idCategoriePreventivo, "ha tutte le categorie del filtro", idCategorieFiltri, "?", esito, filter)

    }

    return esito;
}

const labelRitiroConsegna = timestamp => {
    logger.debug("calcolo la label dal timestamp", timestamp);

    let label = null;

    if(isValid(timestamp)){
        const dow = mappaGiorni3[format(timestamp, "i")];
        const resto = format(timestamp, "dd/MM/yyyy");
        label = `${dow} ${resto}`
    }
    

    return label;
}


const valoreAddizionaleValido = (valore, tipo) => {
    let valido = true;

    if(["D", "I"].includes(tipo)){
        valore = Number(valore);
        valido = !isNaN(valore) && ![null, undefined, 0, ""].includes(valore)                
    }

    if(["S"].includes(tipo)){
        valido = ![null, undefined, ""].includes(valore);
    }

    if(["B"].includes(tipo)){
        valido = [true, 1, "true"].includes(valore)
    }

    return valido;
}

const inizializzaQuotazione = (contesto, dati, eseguiRicalcolo) => {
    /**
         * @type {ResPreventivo}
         */
    const preventivoSel = contesto?.preventivoStorage?.preventivoSelezionato ?? null;
    const addizionaliStorage = contesto?.preventivoStorage?.addizionali ?? null;

    if(preventivoSel !== null){

        const idprodotto = preventivoSel?.price?.associazione?.prodotto?.id ?? null;
        let addizionaliSel = {};

        if(idprodotto !== null){
            addizionaliSel = addizionaliStorage?.[`prodotto_${idprodotto}`] ?? null
        }

        const preventivoRicalcola = dati.find(
            /**
             * 
             * @param {ResPreventivo} p 
             */
            (p) => {
                return Number(p.price.id) === Number(preventivoSel.price.id)
            }
        )


        if(preventivoRicalcola !== undefined){
            logger.debug("in storage ho già un preventivo selezionato, ricalcolo passando", preventivoRicalcola, addizionaliSel)
            eseguiRicalcolo(preventivoRicalcola, addizionaliSel);
        }
    }                
}

/**
 * Dato un preventivo e un addizionale, ritorna un booleano che indica 
 * se l'addizionale è stato selezionato dall'utente. Il controllo si 
 * basa sul tipo dell'addizionale
 * Se il tipo è numerico il valore deve essere un numero valido
 * Se il tipo è stringa il valore non deve essere vuoto
 * Se il tipo è boolean il valore deve essere true
 * In tutti gli altri casi l'addizionale è da considerarsi non selezionato
 * 
 * @param {ResPreventivo} preventivo 
 * @param {{id: Number|String, valore: Object}} addizionale 
 * @returns 
 */
const addizionaleInUso = (preventivo, addizionale, methods, addizionaliById) => {


    const idaddizionale = Number(addizionale.id);
    const idprodotto = Number(preventivo.price.associazione.prodotto.id);
    const addizionaleReale = addizionaliById[idaddizionale];
    let valore = methods.getValues(`addizionali.prodotto_${idprodotto}.addizionale_${idaddizionale}`);
    let utilizzato = valoreAddizionaleValido(valore, addizionaleReale.tipo.value);

    const inUso = {
        valore,
        utilizzato,
        ...addizionaleReale,
    }
    logger.debug("addizionale in uso esteso da addizionale originale", inUso, preventivo)

    return inUso;

}

const listaAddizionaliScelti = (preventivo, addizionali, methods, addizionaliById) => {
    const lista = Object.keys(addizionali).map((chiave) => {
        let [prefisso, id] = chiave.split("_")
        id=Number(id);
        const valore = addizionali[chiave];
        const inUso = addizionaleInUso(preventivo, {id, valore}, methods, addizionaliById)
        const utilizzato = inUso?.utilizzato ?? true

        return {
            id,
            valore,
            prezzo: null,
            utilizzato
        } 
    })           
    
    logger.debug("addizionali scelti per il preventivo", preventivo, lista)
    
    return lista;
}

const contestoAggiornato = (contesto, preventivoaggiornato, methods) => {


    const preventiviaggiornati = contesto.preventivi.quotations.map(preventivo => {
        if(preventivo.price.associazione.prodotto.id === preventivoaggiornato.price.associazione.prodotto.id){
            preventivo = preventivoaggiornato;
            methods.setValue(`totalprices.prodotto_${preventivo.price.associazione.prodotto.id}`, preventivo.totalprice)
            logger.debug("aggiornamento contesto - preventivo aggiornato", preventivo);

        } else {
            const ultimoPrezzoPreventivo = methods.getValues(`totalprices.prodotto_${preventivo.price.associazione.prodotto.id}`)
            logger.debug("aggiornamento contesto - preventivo non aggiornato", preventivo, ultimoPrezzoPreventivo);
            if(ultimoPrezzoPreventivo){
                preventivo.totalprice = ultimoPrezzoPreventivo;
            }
        }
        return preventivo;
    })

    const aggiornamento = {
        ...contesto,
        preventivi: {
            ...contesto.preventivi,
            quotations: preventiviaggiornati
        }
    }

    logger.debug("aggiornamento contesto - contestoAggiornato", preventivoaggiornato, aggiornamento.preventivi.quotations.map(({addizionaliscelti, description, totalprice}) => ({addizionaliscelti, description, totalprice})))

    return aggiornamento;

}

/**
 * Se errore è null svuota tutti gli addizionali e ricalcola
 * Se errore non è null si aspetta di trovare una lista separata da virgola di id addizionali dentro errore.response.data.description
 * La lista di addizionali specificata nell'errore viene svuotata e ricalcola
 */
const svuotaServizi = async (preventivo, listaErrori = null, methods, eseguiRicalcolo) => {
    logger.debug("svuoto i servizi del preventivo", preventivo)
    const idprodotto = preventivo.price.associazione.prodotto.id;                      
    
    if(listaErrori !== null && !listaErrori.length){
        logger.error("attenzione il server ritorna un messaggio di errore non valido! Se è presente un errore in ricalcola deve essere indicato l'addizionale che va in errore!");
    }
    
    if((Array.isArray(listaErrori) && listaErrori.length) || listaErrori === null){
        const addizionali = preventivo.listaaddizionali.reduce((obj, addizionale) => {
            const idaddizionale = Number(addizionale.id);
            
            const k = `addizionale_${idaddizionale}`;

            const nomecampo = `addizionali.prodotto_${idprodotto}.addizionale_${idaddizionale}`;

            let v = methods.getValues(nomecampo);
            

            if((Array.isArray(listaErrori) && listaErrori.includes(idaddizionale)) || listaErrori === null){
                v = addizionale.tipo.value === 'S' ? 
                    '':
                    ["D", "I"].includes(addizionale.tipo.value) ?
                    0 :
                    false;

                logger.debug("svuoto il campo", nomecampo)
                
                methods.resetField(nomecampo, {defaultValue: v});
            }
            
            return {
                ...obj,
                [k]: v
            }
        }, {})

        await eseguiRicalcolo(preventivo, addizionali, false, false);
    }
}

const gestioneErroreRicalcolo = (error, preventivo, setErroriRicalcolo, eseguiRicalcolo, suppressErrors = false) => {
    if(suppressErrors === true){
        logger.debug("gestisco in maniera specifica l'errore di ricalcolo in fase di input dell'utente", error.response.data);
        setErroriRicalcolo({[preventivo.price.id]: error.response.data});
    }

    const [primoErrore, ...altriErrori] = error?.response?.data ?? [];

    const codiceErrore = primoErrore?.code ?? "";

    if(codiceErrore.startsWith("INVALIDSRV")){
        const descrizioneErrore = primoErrore?.description ?? "";

        const errori = [
            ...descrizioneErrore
                .split(",")
                .map(e => e.trim())
                .filter(e => e !== "")
                .map(Number),
        ]
        logger.debug("lista errori ricalcola", errori)
        
        svuotaServizi(preventivo, errori, methods, eseguiRicalcolo);
    }
}

const getCompAddizionale = (addizionale) => {
    const Comp = ["D", "I"].includes(addizionale.tipo.value) ? BSSNumber : 
                    ["S"].includes(addizionale.tipo.value) ? BSSText :                                                     
                    BSSSwitch;
    return Comp;
}

const getPropsCompAddizionale = (prodotto, addizionale, methods, setStatoValoreTesto, preventivo, inUso, cambioValoreServizio) => {
    
    const compStdProps = {
        name:`addizionali.prodotto_${prodotto.id}.addizionale_${addizionale.id}`, 
        label: `${spedizioniweb2.ucfirst((addizionale?.nome?.testo ?? "").toLowerCase())}`,
        methods: methods,                                                                                                                                                                                    
    }


    let compSpecProps = {};

    if(["D", "I", "S"].includes(addizionale.tipo.value)){

        /**@type {import('@mui/material/Input').InputProps} */
        const InputProps =  {   
            startAdornment: (
                <InputAdornment position='start'>
                    <AvatarAddizionale {...{addizionale, preventivo}} disablePopper />                                                                           
                </InputAdornment>
            ),            
            endAdornment: (
                <InputAdornment position='end'>
                    {((inUso?.utilizzato ?? false) === true) && (
                        <CheckCircleOutline color={"primary"} />
                    )}                                                                            
                </InputAdornment>
            ),
        }

        compSpecProps.TextFieldProps = {
            //onChange: e => cambioValoreServizio(e.currentTarget.value, prodotto, preventivo, methods),
            sx: {
                "& .MuiInputBase-root": {px: 0.5, py: 0.8}
            },
            onChange: e => {
                setStatoValoreTesto({
                    valore: e.currentTarget.value,
                    prodotto,
                    preventivo
                })
            },
            InputProps
            
        }
    }

    if(["D", "I"].includes(addizionale.tipo.value)){

        compSpecProps.NumberFormatProps = {
            allowNegative: false,
            //afterChange: (v) => cambioValoreServizio(v, prodotto, preventivo, methods)

        }

        if(addizionale.tipo.value === "I"){
            compSpecProps.NumberFormatProps.decimalScale = 0;
        }

    }    


    if(["B"].includes(addizionale.tipo.value)){
        compSpecProps.SwitchProps = {
            afterChange: (v) => cambioValoreServizio(v, prodotto, preventivo, methods)                                                                
        }
    }

    const compProps = {...compStdProps, ...compSpecProps}

    return compProps;
}

const addizionaleMapperLog = a => ({
    id: a?.id ?? null, 
    valore: a?.valore ?? null
})

const preventivoMapperLog = p => ({
    id: p?.price?.id ?? null, 
    totale: p?.totalprice ?? null, 
    addizionali: (p?.addizionaliscelti ?? []).map(addizionaleMapperLog)
});

export {
    inizializzaQuotazione,
    filtraPreventivi,
    labelRitiroConsegna,
    valoreAddizionaleValido,
    addizionaleInUso,
    listaAddizionaliScelti,
    contestoAggiornato,
    svuotaServizi,
    gestioneErroreRicalcolo,
    getCompAddizionale,
    getPropsCompAddizionale,
    preventivoMapperLog,
    addizionaleMapperLog
}